import React from "react";
import SheetMaterialLookupPanel from "./components/SheetMaterialLookupPanel";

export default function SheetLookupStandalone({ token }) {
  return <SheetMaterialLookupPanel token={token} />;
}
